import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
  min-width: 538px;
`

export const TabContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};

  & > ul {
    min-width: 260px;

    li {
      border-radius: ${props => props.theme.primitives.radius.radius0} ${props => props.theme.primitives.radius.radius2}
        ${props => props.theme.primitives.radius.radius2} ${props => props.theme.primitives.radius.radius0};
    }

    @media screen and (max-width: 1190px) {
      min-width: ${props => props.theme.size.XXL};
    }
  }
`

export const TabContent = styled.div`
  width: 100%;
  min-width: 482px;
  box-shadow: none;
  box-sizing: border-box;

  & > div {
    border-radius: ${props => props.theme.primitives.radius.radius6};
  }

  ${props =>
    props.loading &&
    css`
      min-width: 40rem;
    `}
`
